import { z } from 'zod'

// accepts string in any case, normalizes to upper-case
const rawPotential = z.string().transform((v) => v.toUpperCase())

export const potentialSchema = rawPotential.pipe(
	z.enum(['N1', 'N2', 'N3', 'N4', 'N5']),
)

export type PotentialType = z.infer<typeof potentialSchema>

export type Potential = 'n1' | 'n2' | 'n3' | 'n4' | 'n5'
